import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { GeneralService } from './general.service';
import { HttpParams } from '@angular/common/http';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { ListReceiptMoneyViewModel } from '../view-model/index';
import { MessageService } from 'primeng/components/common/messageservice';
import { ListReceiptMoney, ListReceiptMoneyStatus, ResponseModel } from '../models';
import { async } from 'rxjs/internal/scheduler/async';
import { ListReceiptMoneyNew } from '../models/listReceiptMoneyNew.model';
import { ListReceiptMoneyNewViewModel } from '../models/listReceiptMoneyNewViewModel.model';
import { ListReceiptMoneyNewDetail } from '../models/listReceiptMoneyNewDetail.model';
import { ListReceiptMoneyNewDetailFilter } from '../models/listReceiptMoneyNewDetailFilter.model';
import { ReceiptMoneyFromRiderExport } from '../models/filterReceiptMoneyFromRiderExport.model';


@Injectable()
export class ListReceiptMoneyService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "listReceiptMoney");
  }

  getListByType(type: number, fromDate: string = null, toDate: string = null, arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined) {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging("getListByType", arrCols, params, pageSize, pageNumber)
  }
  async getListReceiptMoneyNew(model:ReceiptMoneyFromRiderExport): Promise<ListReceiptMoneyNew[]> {
    let res = await super.postCustomApi("GetListReceiptMoneyNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data as ListReceiptMoneyNew[];
  }
  async getListReceiptMoneyByLRMNId(LRMId: any, pageNum: any, pageSize: any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append("LRMId", LRMId);
    params = params.append("pageNum", pageNum);
    params = params.append("pageSize", pageSize);
    const res = await super.getCustomApi("GetListReceiptMoneyByLRMNId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async getListShipmentBoxByLRMNId(LRMId?: any, pageNumber?:any, pageSize?:any): Promise<ResponseModel> {
    let params = new HttpParams();
    params = params.append("LRMId", LRMId);
    if(pageNumber)
    params = params.append("pageNumber", pageNumber);

    if(pageSize)
    params = params.append("pageSize", pageSize);
    const res = await super.getCustomApi("GetListShipmentBoxByLRMNId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  getListToConfirmByType(type: number, fromDate: string = null, toDate: string = null, arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined) {
    let params = new HttpParams();
    params = params.append("type", type + "");
    params = params.append("fromDate", fromDate);
    params = params.append("toDate", toDate);
    return super.getCustomApiPaging("GetListToConfirmByType", arrCols, params, pageSize, pageNumber)
  }
  getListReceiptMoneyFromRider(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined) {
    let params = new HttpParams();
    return super.getCustomApiPaging("getListReceiptMoneyFromRider", arrCols, params, pageSize, pageNumber);
  }
  getListShipmentKeepingByEmployee(empId?: number) {
    let params = new HttpParams();
    params = params.append("empId", empId + "");
    return super.getCustomApi("getListShipmentKeepingByEmployee", params);
  }
  async getListReceiptMoneyByEmployeeId(EmpId: any, receiptMoneyTypeId: any, code: any, selectedPoHubCreatedId: any, selectedHubCreated: any, fromDate: any, toDate: any, pageNum: any, pageSize: any): Promise<any[]> {
    let params = new HttpParams();
    if (EmpId)
      params = params.append("EmpId", EmpId);
    if (receiptMoneyTypeId)
      params = params.append("receiptMoneyTypeId", receiptMoneyTypeId)
    if (code)
      params = params.append("code", code);
    if (selectedPoHubCreatedId)
      params = params.append("selectedPoHubCreatedId", selectedPoHubCreatedId);
    if (selectedHubCreated)
      params = params.append("selectedHubCreated", selectedHubCreated);
    if (fromDate)
      params = params.append("fromDate", fromDate);
    if (toDate)
      params = params.append("toDate", toDate);
    if (pageNum)
      params = params.append("pageNum", pageNum);
    if (pageSize)
      params = params.append("pageSize", pageSize);
    let res = await super.getCustomApi("GetListReceiptMoneyByEmployeeId", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  async createListReceiptMoneyNew(model: ListReceiptMoneyNewViewModel) {
    let res = await super.postCustomApi("CreateListReceiptMoneyNew", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }
  getListShipmentKeepingByHub(otherHubId?: number, listReceitMoneyTypeId?: number) {
    let params = new HttpParams();
    params = params.append("otherHubId", otherHubId + "");
    params = params.append("listReceitMoneyTypeId", listReceitMoneyTypeId + "");
    return super.getCustomApi("getListShipmentKeepingByHub", params);
  }
  createListReceiptMoneyFromRider(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("createListReceiptMoneyFromRider", model);
  }
  createListReceiptMoneyToHub(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("CreateListReceiptMoneyToHub", model);
  }
  createListReceiptMoneyToTreasurer(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("createListReceiptMoneyToTreasurer", model);
  }
  createListReceiptMoneyToHubOther(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("CreateListReceiptMoneyToHubOther", model);
  }
  lock(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("lock", model);
  }
  unlock(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("unlock", model);
  }
  confirm(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("Confirm", model);
  }
  cancel(model: ListReceiptMoneyViewModel) {
    return super.postCustomApi("Cancel", model);
  }
  //LRMNew
  lockLRMNew(model: ListReceiptMoneyNew) {
    return super.postCustomApi("lockLRMNew", model);
  }
  unlockLRMNew(model: ListReceiptMoneyNew) {
    return super.postCustomApi("unlockLRMNew", model);
  }
  confirmLRMNew(model: ListReceiptMoneyNew) {
    return super.postCustomApi("ConfirmLRMNew", model);
  }
  cancelLRMNew(model: ListReceiptMoneyNew) {
    return super.postCustomApi("CancelLRMNew", model);
  }
  //Other
  getListReceiptMoneyShipmentByListReceiptMoney(id?: number, arrCols: string[] = []) {
    let params = new HttpParams();
    params = params.append("id", id + "");
    return super.getCustomApiPaging("getListReceiptMoneyShipmentByListReceiptMoney", arrCols, params);
  }
  getListEmployeeKeepingMoney(arrCols: string[] = []) {
    return super.getCustomApiPaging("GetListEmployeeKeepingMoney", arrCols);
  }

  getListByShipmentId(shipmentId: number) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId + "");
    return super.getCustomApi("getListByShipmentId", params);
  }

  async getListByShipmentIdAsync(shipmentId: number): Promise<ListReceiptMoney[]> {
    const res = await this.getListByShipmentId(shipmentId).toPromise();
    // if (!this.isValidResponse(res)) return;
    const data = res.data as ListReceiptMoney[];
    return data;
  }

  getListReceiptByShipmentNumber(shipmentNumber: string) {
    let params = new HttpParams();
    params = params.append("shipmentNumber", shipmentNumber);
    return super.getCustomApi("getListReceiptByShipmentNumber", params);
  }

  async getListReceiptByShipmentNumberAsync(shipmentNumber: string): Promise<ListReceiptMoney[]> {
    const res = await this.getListReceiptByShipmentNumber(shipmentNumber).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListReceiptMoney[];
    return data;
  }

  async getReceiptMoneyDetailShipment(receiptMoneyId: any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append("receiptMoneyId", receiptMoneyId);
    const res = await super.getCustomApi("GetReceiptMoneyDetailShipment", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async getListReceiptMoneyNewDetail(model: ListReceiptMoneyNewDetailFilter): Promise<ListReceiptMoneyNewDetail[]> {
    const res = await this.postCustomApi("GetListReceiptMoneyNewDetail", model).toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as ListReceiptMoneyNewDetail[];
    return data;
  }
}
